// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1743131560201
      var cssReload = require("G:/basf-资料笔记/holi代码/holi2.5/recipe-h5/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  